import React, { useState, useEffect } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    IconLookup,
    IconDefinition,
    findIconDefinition,
} from "@fortawesome/fontawesome-svg-core";
import countriesDropdownValues from "../Utils/CountriesUN";
import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import ConfirmationModal from "./Utils/ConfirmationModal";
import CardHeader from "./Utils/CardHeaderComponent";
import EditableTitle from "./InputComponents/EditableTitle";
import Tooltip from "./InputComponents/Tooltip";

library.add(faTrashCan);
const trashLookup: IconLookup = { prefix: "fas", iconName: "trash-can" };
const trashcanDefinition: IconDefinition = findIconDefinition(trashLookup);
library.add(faAngleRight);
const angleLookup: IconLookup = { prefix: "fas", iconName: "angle-right" };
const angleDefinition: IconDefinition = findIconDefinition(angleLookup);
interface ValueChainProps {
    dropdownValues: {
        tab: string;
        inputName: string;
        listValue: string[];
    }[];
    isCBE: boolean;
    status: number;
    tAndP:
    {
        table: string;
        property: string;
        tooltip: string;
        placeholder: string;
        id: string;
    }[];
    data: {
        // All Set 0

        isCreatingOrEnablingNewValueChains: string;
        isCreatingOrEnablingNewValueChainsText: string;
        isCreatingOrEnablingNewValueChainsIsConfidential: boolean;

        // All Set 1

        noveltyOfTheFeedstock: string;
        noveltyOfTheFeedstockText: string;
        noveltyOfTheFeedstockSensitive: boolean;

        // All Set 2

        noveltyOfTheTechnologies: string;
        noveltyOfTheTechnologiesText: string;
        noveltyOfTheTechnologiesSensitive: boolean;

        // All Set 3

        noveltyOfTheMarkets: string;
        noveltyOfTheMarketsText: string;
        noveltyOfTheMarketsSensitive: boolean;
    };
    errors: string[];
    handleDeleteValueChain: () => void;
    handleOnChangeValueChain: (e: React.ChangeEvent<any>) => void;

    customLabelValues: {
        table: string;
        property: string;
        value: string;
        id: string;
    }[];
    handleUpdateEditableTitle: (id: string, value: string) => void;
}
function ValueChain({
    data,
    handleDeleteValueChain,
    handleOnChangeValueChain,
    isCBE,
    dropdownValues,
    status,
    errors,
    customLabelValues,
    handleUpdateEditableTitle,
    tAndP
}: ValueChainProps) {
    const [isHidden, setIsHidden] = useState(true);
    const toggleVisibility = () => {
        setIsHidden((prevState) => !prevState);
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleDeleteClick = () => {
        setIsModalOpen(true);
    };
    const confirmDelete = () => {
        setIsModalOpen(false);
        handleDeleteValueChain();
    };
    const cancelDelete = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div className="feedstock-container">
                <CardHeader
                    isHidden={isHidden}
                    toggleVisibility={toggleVisibility}
                    cardName="Value Chain"
                    handleDelete={status == 1 ? handleDeleteClick : null}
                    notValid={errors.length > 0}
                />
                <div className={isHidden ? "hidden-content" : "visible-content"}>
                    <div className="form-container">
                        <div className="error-container">
                            {errors.map((error, index) => (
                                <div
                                    className="error-text"
                                    key={index}
                                    style={{ marginBottom: "10px" }}
                                >
                                    {error}
                                </div>
                            ))}
                        </div>
                        <div className="questions-wrapper">
                        {/* ############ SET 1 ############ */}
                        <div className="question-group-input-first">
                            <div className="row">
                                <div className="col-12">
                                    <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 2")?.tooltip}>
                                        <div className="question-text">
                                            {isCBE ? "CBE JU " : "BBI JU "}KPI 2  🛈 <br />
                                            <EditableTitle
                                                customLabelValue={customLabelValues.find(item => item.property == "isCreatingOrEnablingNewValueChains")}
                                                handleUpdateEditableTitle={handleUpdateEditableTitle} />
                                        </div>
                                    </Tooltip>
                                    <DropdownStringMandatory
                                        listInputs={["-", "Yes", "No"]}
                                        label={""}
                                        inputName={"isCreatingOrEnablingNewValueChains"}
                                        value={data.isCreatingOrEnablingNewValueChains}
                                        handleOnChange={handleOnChangeValueChain}
                                        invalidValues={["-"]}
                                    />
                                </div>
                                <div className="col-12">
                                    <div
                                        className={
                                            data.isCreatingOrEnablingNewValueChains == "Yes"
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <TextConfidential
                                            label={"Explain the value chain "}
                                            textValid={
                                                data.isCreatingOrEnablingNewValueChainsText.length > 4
                                            }
                                            textValue={data.isCreatingOrEnablingNewValueChainsText}
                                            textName={"isCreatingOrEnablingNewValueChainsText"}
                                            onChange={handleOnChangeValueChain}
                                            isConfidential={
                                                data.isCreatingOrEnablingNewValueChainsIsConfidential
                                            }
                                            confidentialInputName={
                                                "isCreatingOrEnablingNewValueChainsIsConfidential"
                                            }
                                            display={false}
                                            editableTitle={<EditableTitle
                                                customLabelValue={customLabelValues.find(item => item.property == "isCreatingOrEnablingNewValueChainsText")}
                                                handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                            placeholder={tAndP.find(item => item.property == "CBE JU KPI 2")?.placeholder}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                data.isCreatingOrEnablingNewValueChains == "Yes"
                                    ? "visible-content"
                                    : "hidden-content"
                            }
                        >
                            <div className="question-group-input">
                                {/* ############ SET 2 ############ */}
                                <div className="question-text">

                                    <EditableTitle
                                        customLabelValue={customLabelValues.find(item => item.property == "novelty")}
                                        handleUpdateEditableTitle={handleUpdateEditableTitle} />
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropdownStringMandatory
                                            listInputs={
                                                dropdownValues.filter(
                                                    (item) => item.inputName == "noveltyOfTheFeedstock"
                                                )[0].listValue
                                            }
                                            label={"Novelty of the Feedstock "}
                                            inputName={"noveltyOfTheFeedstock"}
                                            value={data.noveltyOfTheFeedstock}
                                            handleOnChange={handleOnChangeValueChain}
                                            invalidValues={["-", ""]}
                                            editableTitle={
                                                <EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "noveltyOfTheFeedstock")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div
                                            className={
                                                data.noveltyOfTheFeedstock == "-" ||
                                                    data.noveltyOfTheFeedstock == "" ||
                                                    data.noveltyOfTheFeedstock == "N/A"
                                                    ? "hidden-content"
                                                    : "visible-content"
                                            }
                                        >
                                            <TextConfidential
                                                label={" Please explain the novelty"}
                                                textValid={
                                                    data.noveltyOfTheFeedstockText.length > 4
                                                }
                                                textValue={data.noveltyOfTheFeedstockText}
                                                textName={"noveltyOfTheFeedstockText"}
                                                onChange={handleOnChangeValueChain}
                                                isConfidential={data.noveltyOfTheFeedstockSensitive}
                                                confidentialInputName={"noveltyOfTheFeedstockSensitive"}
                                                display={false}
                                                editableTitle={
                                                    <EditableTitle
                                                        customLabelValue={customLabelValues.find(item => item.property == "noveltyOfTheFeedstockText")}
                                                        handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* ############ SET 3 ############ */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="input-margin-top">
                                            <DropdownStringMandatory
                                                listInputs={
                                                    dropdownValues.filter(
                                                        (item) =>
                                                            item.inputName == "noveltyOfTheTechnologies"
                                                    )[0].listValue
                                                }
                                                label={"Novelty of the Technologies"}
                                                inputName={"noveltyOfTheTechnologies"}
                                                value={data.noveltyOfTheTechnologies}
                                                handleOnChange={handleOnChangeValueChain}
                                                invalidValues={["-", ""]}
                                                editableTitle={<EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "noveltyOfTheTechnologies")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div
                                            className={
                                                data.noveltyOfTheTechnologies == "-" ||
                                                    data.noveltyOfTheTechnologies == "" ||
                                                    data.noveltyOfTheTechnologies == "N/A"
                                                    ? "hidden-content"
                                                    : "visible-content"
                                            }
                                        >
                                            <TextConfidential
                                                label={"Please explain the novelty"}
                                                textValid={
                                                    data.noveltyOfTheTechnologiesText.length > 4
                                                }
                                                textValue={data.noveltyOfTheTechnologiesText}
                                                textName={"noveltyOfTheTechnologiesText"}
                                                onChange={handleOnChangeValueChain}
                                                isConfidential={data.noveltyOfTheTechnologiesSensitive}
                                                confidentialInputName={
                                                    "noveltyOfTheTechnologiesSensitive"
                                                }
                                                display={false}
                                                editableTitle={<EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "noveltyOfTheTechnologiesText")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* ############ SET 4 ############ */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropdownStringMandatory
                                            listInputs={
                                                dropdownValues.filter(
                                                    (item) => item.inputName == "noveltyOfTheMarkets"
                                                )[0].listValue
                                            }
                                            label={"Novelty of the Markets"}
                                            inputName={"noveltyOfTheMarkets"}
                                            value={data.noveltyOfTheMarkets}
                                            handleOnChange={handleOnChangeValueChain}
                                            invalidValues={["-", ""]}
                                            editableTitle={<EditableTitle
                                                customLabelValue={customLabelValues.find(item => item.property == "noveltyOfTheMarkets")}
                                                handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div
                                            className={
                                                data.noveltyOfTheMarkets == "" ||
                                                    data.noveltyOfTheMarkets == "-" ||
                                                    data.noveltyOfTheMarkets == "N/A"
                                                    ? "hidden-content"
                                                    : "visible-content"
                                            }
                                        >
                                            <TextConfidential
                                                label={"Please explain the novelty"}
                                                textValid={
                                                    data.noveltyOfTheMarketsText.length > 4
                                                }
                                                textValue={data.noveltyOfTheMarketsText}
                                                textName={"noveltyOfTheMarketsText"}
                                                onChange={handleOnChangeValueChain}
                                                isConfidential={data.noveltyOfTheMarketsSensitive}
                                                confidentialInputName={"noveltyOfTheMarketsSensitive"}
                                                display={false}
                                                editableTitle={<EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "noveltyOfTheMarketsText")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={cancelDelete}
                onConfirm={confirmDelete}
                title="
        Confirm deletion"
                message="Are you sure you want to delete this component ?"
            />
        </>
    );
}
export default ValueChain;
